import { Device } from '@bcf-shared-settings/settings/types';

export const deviceBase: Device = {
  type: 'mobile-web'
};
